import { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { InputBase, IconButton } from '@material-ui/core';
import { CheckIcon, CloseIcon } from '../../../../components/Icon';
import { i18n } from '../../../../language';
import lengthVerification from '../../../../utils/lengthVerification';

const useStyles = makeStyles((theme) => ({
  add: {
    width: '100%',
    minHeight: '3.75rem',
    height: '100%',
    padding: '0 1.25rem 0 1.938rem',
    marginBottom: '0.625rem',
    borderRadius: '0.5rem',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    position: 'relative',
    overflow: 'hidden',
    border: '0.0625rem solid #538fff',
  },
  edit: (type) => ({
    width: '100%',
    minHeight: '3.75rem',
    height: '100%',
    padding: '0 1.25rem 0 1.938rem',
    marginBottom: '0.625rem',
    borderRadius: '0.5rem',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    position: 'relative',
    overflow: 'hidden',
    border: '0.0625rem solid #538fff',
    '&::before': {
      position: 'absolute',
      top: '0',
      left: '0',
      content: '""',
      display: 'block',
      width: '0.22rem',
      height: '3.75rem',
      backgroundColor: type === 2 ? theme.palette.primary.main : theme.palette.font.main,
      zIndex: '9',
    },
  }),
  input: {
    fontFamily: 'NotoSans-Medium',
    width: '90%',
    fontSize: '1.125rem',
    color: theme.palette.font.main,
    fontWeight: '500',
  },
  btn: {
    display: 'flex',
  },
  button: {
    width: '1.5rem',
    height: '1.5rem',
    borderRadius: '0',
    backgroundColor: theme.palette.font.white,
    '&:hover': {
      backgroundColor: theme.palette.font.white,
    },
  },
  check: {
    fontSize: '1.188rem',
    color: theme.palette.primary.main,
    marginRight: '1.938rem',
  },
  close: {
    fontSize: '1rem',
    color: theme.palette.primary.main,
  },
}));

export default function Edit({ setBtnopen, add, edit, text, setEdit, handleAdd, handleUpdate, id, type,rowIndex }) {
  const classes = useStyles(type);

  function styleContrl(props) {
    return props ? classes.edit : classes.add;
  }

  const [value, setValue] = useState(text);

  const handleChange = (event) => {
    if (lengthVerification(event.target.value, 201)) {
      return;
    }
    setValue(event.target.value);
  };

  const handleOk = () => {
    if (value.length === 0) {
      return;
    }

    if (add) {
      if (value === undefined) {
        setBtnopen(true);
        return null;
      }
      handleAdd(value);
      return null;
    }
    if(id<0){
      handleAdd(value,rowIndex);
    }else{
      handleUpdate(id, value);
    }
    setEdit(false);
  };

  const handleClose = () => {
    add ? setBtnopen(true) : setEdit(false);
  };

  return (
    <div className={styleContrl(edit)} style={{borderColor:id<0?"orange":null}}>
      <InputBase
        className={classes.input}
        value={value}
        multiline
        placeholder={i18n.t('DUTYASSIGN_FOOTNOTE_INPUT')}
        onChange={handleChange}
        id={`DutyAssign-InputBase-ada-${id}`}
      />
      <div className={classes.btn}>
        <IconButton
          className={classes.button}
          onClick={handleOk}
          id={`DutyAssign-IconButton-adb-${id}`}
          style={{ opacity: value.length === 0 ? 0.2 : 1 }}
        >
          <CheckIcon className={classes.check} />
        </IconButton>
        <IconButton className={classes.button} onClick={handleClose} id={`DutyAssign-IconButton-adc-${id}`}>
          <CloseIcon className={classes.close} />
        </IconButton>
      </div>
    </div>
  );
}
